import { parseIsoDate, formatIsoDate } from 'helpers/DateHelper';
import { add } from 'date-fns';
import capacityUtilizationProperties from 'enums/capacityUtilizationProperties';
import capacityUtilizationCategories from 'enums/capacityUtilizationCategories';

export const calculateChartData = (storageSites, fromDate, toDate, appContext) => {
    const dailyDataDictionary = {}; // dateString -> { date, capacityUtilization }
    let date;
    let currency = undefined;
    storageSites.forEach(storageSite => {
        storageSite.bookingCalendar.capacityUtilizations.forEach(capacityUtilization => {
            currency = getCurrency(getDataPoint(capacityUtilization, capacityUtilizationCategories.booked).value, currency)
                       ??
                       getCurrency(getDataPoint(capacityUtilization, capacityUtilizationCategories.total).value, currency);
            const intervalStartDate = parseIsoDate(capacityUtilization.interval.startDate);
            const intervalEndDate = parseIsoDate(capacityUtilization.interval.endDate);
            date = intervalStartDate;
            const categoryDataPoints = {};
            Object.values(capacityUtilizationCategories).forEach(category => {
                categoryDataPoints[category.key] = getDataPoint(capacityUtilization, category);
            });
            while(date <= intervalEndDate) {
                const dateKey = formatIsoDate(date, appContext);
                if(!dailyDataDictionary[dateKey]) {
                    dailyDataDictionary[dateKey] = createDailyData(date);
                }
                const item = dailyDataDictionary[dateKey];
                Object.values(capacityUtilizationCategories)
                    .forEach(category => {
                        const dailyDp = getDataPoint(item.capacityUtilization, category);
                        const dp = categoryDataPoints[category.key];
                        dailyDp.count += dp.count;
                        dailyDp.area += dp.area;
                        addToAmountSum(dailyDp.value, dp.value);
                    });
                date = add(date, { days: 1 });
            }
        });
    });

    const itemsToReturn = [];
    date = fromDate;
    while(date <= toDate) {
        const dateKey = formatIsoDate(date, appContext);
        itemsToReturn.push(dailyDataDictionary[dateKey] ?? createDailyData(date));
        date = add(date, { days: 1 });
    }
    return itemsToReturn;
};

export const getCapacityUtilizationForDate = (storageSite, date) =>
    storageSite.bookingCalendar.capacityUtilizations.find(capacityUtilization => {
        const intervalStartDate = parseIsoDate(capacityUtilization.interval.startDate);
        const intervalEndDate = parseIsoDate(capacityUtilization.interval.endDate);
        return date >= intervalStartDate && date <= intervalEndDate;
    });

export const getAllColumnsForProperty = property => [property].concat((property.additionalColumns ?? []).map(key => capacityUtilizationProperties[key]));

const createDailyData = date => ({
    date,
    capacityUtilization: {
        categoryDataPoints: Object.values(capacityUtilizationCategories)
            .map(category => ({
                category: category.key,
                dataPoint: {
                    count: 0,
                    area: 0,
                    value: { currencySums: [] }
                }
            }))
    }
});

export const getDataPoint = (capacityUtilization, category) => capacityUtilization.categoryDataPoints.find(o => o.category === category.key).dataPoint;

export const getCurrency = (amountSum, defaultValue) => amountSum.currencySums.length === 0 || defaultValue !== undefined
    ? defaultValue
    : amountSum.currencySums[0].currency;

export const getValueForCurrency = (amountSum, currency) => {
    if (amountSum.currencySums.length === 0) {
        return 0;
    }
    const amountSumForCurrency = amountSum.currencySums.find(o => o.currency === currency);
    return amountSumForCurrency?.value ?? 0;
};

const addToAmountSum = (existingAmountSum, amountSumToAdd) => {
    amountSumToAdd.currencySums.forEach(cs => {
        let existingCurrencySum = existingAmountSum.currencySums.find(ecs => ecs.currency === cs.currency);
        if(!existingCurrencySum) {
            existingCurrencySum = {
                value: 0,
                currency: cs.currency
            };
            existingAmountSum.currencySums.push(existingCurrencySum);
        }
        existingCurrencySum.value += cs.value;
    });
};
